document.addEventListener('DOMContentLoaded', function() {

  const VARIANT_NAME_PROPERTY = 'option2';
  const productJsonElement = document.getElementById('product-json-data');
  if (!productJsonElement) {
    console.error("Fatal Error: Could not find the product data element.");
    return;
  }
  const productJson = JSON.parse(productJsonElement.textContent);
  if (!productJson || !productJson.variants) return;

  // Read variant metafields (backorder, etc.)
  const metafieldsElement = document.getElementById('variant-metafields-data');
  const variantMetafields = metafieldsElement ? JSON.parse(metafieldsElement.textContent) : {};

  // --- Delivery Indicator Config ---
  const BACKORDER_EXTRA_DAYS = 7; // Extra days added to delivery when variant is on backorder

  const _currency = window.Shopify?.currency?.active || 'EUR';
  const _currencyLocaleMap = {
    EUR: 'de-DE', USD: 'en-US', GBP: 'en-GB', CAD: 'en-CA',
    AUD: 'en-AU', NZD: 'en-NZ', CHF: 'de-CH',
    NOK: 'nb-NO', SEK: 'sv-SE', DKK: 'da-DK', JPY: 'ja-JP',
  };
  const currencyFormatter = new Intl.NumberFormat(_currencyLocaleMap[_currency] || undefined, {
    style: 'currency',
    currency: _currency
  });
  const formatPrice = (cents) => currencyFormatter.format(cents / 100);

  // Returns the currently selected colour from PageFly's colour radio buttons
  const getSelectedColor = () => {
    const checked = document.querySelector('.pf-vs-color input[type="radio"]:checked');
    return checked ? checked.value : null;
  };

  // Finds the best-matching variant for a given pack size, preferring the selected colour
  const findVariantForPack = (packName) => {
    const color = getSelectedColor();
    if (color) {
      const match = productJson.variants.find(v => v[VARIANT_NAME_PROPERTY] === packName && v.option1 === color);
      if (match) return match;
    }
    return productJson.variants.find(v => v[VARIANT_NAME_PROPERTY] === packName);
  };

  const getPackSize = (name) => {
    if (!name) return 1;
    if (name.toLowerCase().includes('double')) return 2;
    const num = parseInt(name, 10);
    return isNaN(num) ? 1 : num;
  };

  // --- 1. UPDATE: Dynamic Shipping Badge ---
  function updateShippingBadge(variant) {
    const displayElement = document.getElementById('price-per-item-display');
    if (!displayElement || !variant) return;

    const variantName = variant[VARIANT_NAME_PROPERTY];

    if (getPackSize(variantName) === 6) {
      displayElement.innerText = "Free International Shipping";
      displayElement.classList.add('is-visible');
    } else {
      displayElement.classList.remove('is-visible');
      setTimeout(() => {
        if (!displayElement.classList.contains('is-visible')) displayElement.innerText = '';
      }, 500);
    }
  }

  // --- 2. Sticky Price (unchanged) ---
  function updateStickyPrice(variant) {
    const priceElement = document.getElementById('sticky-price-display');
    if (!priceElement || !variant) return;
    priceElement.innerText = formatPrice(variant.price);
  }

  // --- 3. Main Info (Sold Out, Savings, Unit Price) ---
  function updateVariantInfoInButtons() {
    productJson.variants.forEach(variant => {
      const currentVariantName = variant[VARIANT_NAME_PROPERTY];
      const targetButtons = document.querySelectorAll(`.custom-variant-button[data-variant="${currentVariantName}"]`);

      const packSize = getPackSize(currentVariantName);
      let unitPriceText = "";
      if (packSize > 0) {
        const pricePerItem = (variant.price / 100) / packSize;
        unitPriceText = `${formatPrice(variant.price / packSize)} / pc`;
      }

      targetButtons.forEach(targetButton => {
        // A. Update Unit Price Text
        const unitPriceDiv = targetButton.querySelector('.variant-unit-price');
        if (unitPriceDiv) {
           unitPriceDiv.innerText = unitPriceText;
        }

        // B. Free Shipping badge (6-Pack only)
        if (packSize === 6 && !targetButton.querySelector('.free-shipping-badge')) {
          const badge = document.createElement('span');
          badge.className = 'free-shipping-badge';
          badge.innerText = 'FREE SHIPPING';
          targetButton.appendChild(badge);
        }

        // C. Update Pills
        const savingsPill = targetButton.querySelector('.savings-pill');
        if (!savingsPill) return;

        if (!variant.available) {
          savingsPill.innerText = 'Sold Out';
          savingsPill.classList.add('sold-out');
          savingsPill.style.display = 'flex';
          targetButton.classList.add('is-sold-out');
        }
        else if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          savingsPill.classList.remove('sold-out');
          targetButton.classList.remove('is-sold-out');
          const savings = ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100;
          savingsPill.innerText = `-${Math.round(savings)}%`;
          savingsPill.style.display = 'flex';
        }
        else {
          savingsPill.classList.remove('sold-out');
          targetButton.classList.remove('is-sold-out');
          savingsPill.innerText = '';
          savingsPill.style.display = 'none';
        }
      });
    });
  }

  // --- 4. Initialize Buttons ---
  function initializeVariantButtons() {
    const allCustomButtons = document.querySelectorAll('.custom-variant-button');
    if (allCustomButtons.length === 0) return;

    allCustomButtons.forEach(button => {
      button.addEventListener('click', function() {
        const variantName = this.getAttribute('data-variant');
        const selectedVariant = findVariantForPack(variantName);

        // Update Sticky Price, Shipping Badge AND Delivery Indicator
        if (selectedVariant) {
          updateStickyPrice(selectedVariant);
          updateShippingBadge(selectedVariant);
          const isBackorder = (variantMetafields[selectedVariant.id] || {}).backorder === true;
          renderDeliveryDates(isBackorder ? BACKORDER_EXTRA_DAYS : 0);
        }

        const pageflyRadioButton = document.querySelector(`.pf-option-swatches input[type="radio"][value="${variantName}"]`);
        if (pageflyRadioButton) {
          pageflyRadioButton.click();
        }

        allCustomButtons.forEach(btn => {
          if (btn.getAttribute('data-variant') === variantName) {
            btn.classList.add('active');
          } else {
            btn.classList.remove('active');
          }
        });
      });
    });
  }

  // --- 5. Sticky Bar Logic (unchanged) ---
  function initializeStickyBar() {
    const stickyBar = document.getElementById('sticky-atc-bar');
    const mainButton = document.getElementById('main-atc-wrapper');
    const mainPlaceholder = document.getElementById('main-atc-placeholder');
    const stickyPlaceholder = document.getElementById('sticky-atc-placeholder');

    if (!stickyBar || !mainButton || !mainPlaceholder || !stickyPlaceholder) {
      console.warn('Sticky Bar Error: Missing key elements.');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) {
          stickyPlaceholder.appendChild(mainButton);
          stickyBar.classList.add('is-visible');
        } else {
          stickyBar.classList.remove('is-visible');
          setTimeout(() => {
            mainPlaceholder.appendChild(mainButton);
          }, 400);
        }
      },
      { threshold: 0 }
    );
    observer.observe(mainPlaceholder);
  }

  // --- 6. Set Initial State ---
  function setInitialVariant() {
    const allMainButtons = Array.from(document.querySelectorAll('.custom-variant-container .custom-variant-button'));
    if (allMainButtons.length === 0) return;

    // Find the HTML-defined active button, or fall back to the first
    const markedActive = allMainButtons.find(btn => btn.classList.contains('active')) || allMainButtons[0];
    const startIndex = allMainButtons.indexOf(markedActive);

    // Walk buttons starting from the marked one — skip if all its variants are sold out
    let selectedBtn = null;
    for (let i = 0; i < allMainButtons.length; i++) {
      const btn = allMainButtons[(startIndex + i) % allMainButtons.length];
      const variantName = btn.getAttribute('data-variant');
      const hasAvailable = productJson.variants.some(v => v[VARIANT_NAME_PROPERTY] === variantName && v.available);
      if (hasAvailable) {
        selectedBtn = btn;
        break;
      }
    }

    // If everything is sold out, fall back to the originally marked button
    if (!selectedBtn) selectedBtn = markedActive;

    const variantName = selectedBtn.getAttribute('data-variant');
    const selectedVariant = productJson.variants.find(v => v[VARIANT_NAME_PROPERTY] === variantName);

    // Sync active class on all buttons (main + sticky)
    document.querySelectorAll('.custom-variant-button').forEach(btn => {
      if (btn.getAttribute('data-variant') === variantName) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });

    if (selectedVariant) {
      updateStickyPrice(selectedVariant);
      updateShippingBadge(selectedVariant);
      _currentExtraDays = (variantMetafields[selectedVariant.id] || {}).backorder === true ? BACKORDER_EXTRA_DAYS : 0;

      const pageflyRadioButton = document.querySelector(`.pf-option-swatches input[type="radio"][value="${variantName}"]`);
      if (pageflyRadioButton) {
        setTimeout(() => { pageflyRadioButton.click(); }, 100);
      }
    }
  }

  // --- 7. Delivery Indicator ---
  let _deliveryMinDays = 7; // fallback defaults
  let _deliveryMaxDays = 10;
  let _currentExtraDays = 0;

  function calculateDeliveryDate(startDate, daysToAdd) {
    const date = new Date(startDate.getTime());
    let added = 0;
    while (added < daysToAdd) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0) added++; // skip Sundays
    }
    return date;
  }

  function renderDeliveryDates(extraDays) {
    _currentExtraDays = extraDays;
    const el = document.getElementById('estimated-delivery');
    const dot = document.querySelector('.blinking-dot');
    if (!el) return;

    const opts = { day: 'numeric', month: 'short' };
    const today = new Date();
    const minStr = calculateDeliveryDate(today, _deliveryMinDays + extraDays).toLocaleDateString('en-GB', opts);
    const maxStr = calculateDeliveryDate(today, _deliveryMaxDays + extraDays).toLocaleDateString('en-GB', opts);
    el.innerText = `${minStr} - ${maxStr}`;

    if (dot) dot.style.backgroundColor = extraDays > 0 ? '#e07b00' : '#28a745';
  }

  function initDeliveryIndicator() {
    const euCountries = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE',
                         'FI', 'FR', 'GR', 'HU', 'IE', 'IT', 'LV',
                         'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK',
                         'SI', 'ES', 'SE'];

    fetch('https://ipapi.co/json/')
      .then(r => r.json())
      .then(data => {
        const cc = data.country_code;
        if (cc === 'DE') {
          _deliveryMinDays = 2; _deliveryMaxDays = 3;
        } else if (euCountries.includes(cc)) {
          _deliveryMinDays = 3; _deliveryMaxDays = 5;
        } else {
          _deliveryMinDays = 7; _deliveryMaxDays = 10;
        }
        if (cc === 'US') {
          document.querySelectorAll('.free-shipping-badge').forEach(el => el.style.display = 'none');
        }
        renderDeliveryDates(_currentExtraDays); // re-render with correct country + current variant state
      })
      .catch(() => {
        _deliveryMinDays = 7; _deliveryMaxDays = 10;
        renderDeliveryDates(_currentExtraDays);
      });
  }

  // --- 8. Colour Swatch Sold Out + Backorder State ---
  function updateColorSwatchAvailability() {
    // Group variants by color (option1)
    const colorVariants = {};
    productJson.variants.forEach(variant => {
      const color = variant.option1;
      if (!colorVariants[color]) colorVariants[color] = [];
      colorVariants[color].push(variant);
    });

    Object.entries(colorVariants).forEach(([color, variants]) => {
      const swatchDiv = document.querySelector(`.pf-vs-color input[value="${color}"]`)?.closest('.pf-vs-color');
      if (!swatchDiv) return;

      const allSoldOut = variants.every(v => !v.available);
      const hasBackorder = variants.some(v => (variantMetafields[v.id] || {}).backorder === true);

      if (allSoldOut) {
        swatchDiv.classList.add('is-color-sold-out');
        swatchDiv.classList.remove('is-color-backorder');
      } else if (hasBackorder) {
        swatchDiv.classList.add('is-color-backorder');
        swatchDiv.classList.remove('is-color-sold-out');
      } else {
        swatchDiv.classList.remove('is-color-sold-out', 'is-color-backorder');
      }
    });
  }

  // --- 9. Re-evaluate delivery when colour swatch changes ---
  function initColorSwatchListener() {
    document.querySelectorAll('.pf-vs-color input[type="radio"]').forEach(radio => {
      radio.addEventListener('change', function() {
        // Find the currently active pack button to get the pack name
        const activePackBtn = document.querySelector('.custom-variant-container .custom-variant-button.active');
        if (!activePackBtn) return;
        const packName = activePackBtn.getAttribute('data-variant');
        const variant = productJson.variants.find(v => v[VARIANT_NAME_PROPERTY] === packName && v.option1 === this.value);
        if (!variant) return;
        const isBackorder = (variantMetafields[variant.id] || {}).backorder === true;
        renderDeliveryDates(isBackorder ? BACKORDER_EXTRA_DAYS : 0);
        updateStickyPrice(variant);
        updateShippingBadge(variant);
      });
    });
  }

  // Run everything
  updateVariantInfoInButtons();
  initializeVariantButtons();
  initializeStickyBar();
  setInitialVariant();          // sets _currentExtraDays for initial variant
  updateColorSwatchAvailability();
  initColorSwatchListener();    // updates delivery + price when colour swatch changes
  initDeliveryIndicator();      // fetches country, then renders dates using _currentExtraDays
});
